import { action, observable } from 'mobx';

// share dependencies
import  ColorDialogUtils from 'share/components/controls/ColorDialog/Izenda.ColorDialogUtils';

// data imports
import { textProperties, CUSTOM_URL } from 'logic/data/Izenda.ReportPartKPIConstants';



/**
 * @class TextTileProperties
 * @description contains property values for KPI Text tiles
 */
export default class TextTileProperties {
    @observable fontFormat = {
        ...textProperties.font
    };

    @observable fontStyle = {
        ...textProperties.fontStyle
    };

    @observable color = {
        ...textProperties.color
    };

    @observable alignment = textProperties.alignment;

    @observable customURL = { option: CUSTOM_URL.DEFAULT_VALUE, url: '' }

    @observable border = {
        ...textProperties.border
    };

    constructor(textProperties) {
        if (textProperties) {
            this.alignment = textProperties.alignment;
            this.color = textProperties.color;
            this.fontFormat = textProperties.fontFormat;
            this.fontStyle = textProperties.fontStyle;
            this.customURL = textProperties.customURL;
            this.border = textProperties.border;
        }
    }


    /**
     * @method updateProperties
     * @description reset property values with new values
     * @param {object} newProps changed properties
     */
    @action
    updateProperties(newProps) {
        Object.keys(newProps).forEach(key => this[key] = newProps[key]);
    }

    /**
     * @method getStyle
     * @description create React style object based off of properties
     */
    getStyle() {
        const {
            alignment,
            border,
            color,
            fontFormat,
            fontStyle,
            customURL
        } = this;
        const cursorType = customURL && customURL.url == '' ? 'text' : 'pointer';
        
        return {
            backgroundColor: ColorDialogUtils.convertHexToRGBA(color.backgroundColor,color.alpha),
            color: color.textColor, 
            fontFamily: fontFormat.fontFamily,
            fontSize: fontFormat.fontSize,
            fontWeight: fontStyle.fontBold ? 'bold' : 'normal',
            fontStyle: fontStyle.fontItalic ? 'italic' : 'normal',
            textAlign: alignment,
            textDecoration: fontStyle.fontUnderline ? 'underline' : 'none',
            cursor: cursorType
        };
    }

    /**
     * @method getBorderStyle
     * @description create React style object for border styles
     */
    getBorderStyle() {
        const {
            top,
            right,
            bottom,
            left
        } = this.border;
        return {
            borderTopStyle: top.dashStyle,
            borderTopWidth: `${top.thinkness}px`,
            borderTopColor: top.color,
            borderRightStyle: right.dashStyle,
            borderRightWidth: `${right.thinkness}px`,
            borderRightColor: right.color,
            borderBottomStyle: bottom.dashStyle,
            borderBottomWidth: `${bottom.thinkness}px`,
            borderBottomColor: bottom.color,
            borderLeftStyle: left.dashStyle,
            borderLeftWidth: `${left.thinkness}px`,
            borderLeftColor: left.color
        };
    }
}



// WEBPACK FOOTER //
// ./ui/logic/models/ReportPartKPIModels/Izenda.TextTileProperties.js